import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de276c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menuWithTabsContent"
}

import { BtnsForTabsMenuType } from '@/types';
import { Component, computed, markRaw, onMounted, ref, Ref, watch } from 'vue';
import { EditProfileInfo, ProfileInfo, ProfileView } from './index';
import { DocumentList } from '@/components';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const getActiveComponent = (btnId: string | number) => {
  activeComponentBtnId.value = btnId;

  return componentBtns.value.find(el => el.id === btnId)?.component;
};

const getCurrentProperties = (btnId: string | number) => {
  if (btnId === 'documents') {
    return {
      documents: [
        {
          id: 1,
          name: 'Документы',
          path: '',
        },
      ],
    };
  }

  return {};
};

const componentBtns = computed((): BtnsForTabsMenuType[] => {
  return [
    {
      id: 'info',
      title: 'Профиль',
      component: markRaw(ProfileInfo),
      hide: activeComponentBtnId.value === 'editProfile',
    },
    {
      id: 'editProfile',
      title: 'Профиль',
      component: markRaw(EditProfileInfo),
      hide: activeComponentBtnId.value !== 'editProfile',
    },
    { id: 'documents', title: 'Документы', component: markRaw(DocumentList) },
    { id: 'view', title: 'Вид профиля', component: markRaw(ProfileView) },
  ];
});

const activeComponentBtnId: Ref<undefined | string | number> = ref(undefined);

const router = useRouter();
const changeActiveBtn = (btnId: string | number) => {
  activeComponentBtnId.value = btnId;
  router.push({ query: { menuItem: btnId } });
};

const route = useRoute();

const activeBtnId = computed(() => {
  return route?.query.menuItem;
});

const updateActiveBtn = () => {
  if (
    activeBtnId.value &&
    !!componentBtns.value.find(el => el.id === activeBtnId.value)
  ) {
    changeActiveBtn(`${activeBtnId.value}`);
  } else {
    changeActiveBtn(componentBtns.value[0].id);
  }
};

onMounted(() => {
  updateActiveBtn();
});

watch(
  () => activeBtnId.value,
  () => {
    updateActiveBtn();
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!

  return (_openBlock(), _createBlock(_component_base_menu_with_tabs, {
    activeComponent: activeComponentBtnId.value,
    componentBtns: componentBtns.value.filter(el => !el.hide),
    bgColor: "#fff",
    withRadius: "",
    onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (changeActiveBtn($event)))
  }, {
    content: _withCtx((contentProps) => [
      (getActiveComponent(contentProps.data))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(getActiveComponent(contentProps.data)), _mergeProps({
              key: contentProps.data
            }, getCurrentProperties(contentProps.data)), null, 16))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["activeComponent", "componentBtns"]))
}
}

})